/* eslint-disable tailwindcss/no-custom-classname */
import Link from 'next/link'
import { Writer as WriterType } from '@/types/summary'

interface Props {
  writer: WriterType
}
export const Writer: React.FC<Props> = ({ writer }) => {
  return (
    <div className="flex pt-[10px] w-full border-t border-[#e6e6e6] border-solid">
      <div>
        <img src={writer.image} alt="ライター画像" className="w-12" />
      </div>
      <div className="ml-[10px]">
        <div>{writer.name}</div>
        <div className="text-sm">
          <Link href={`/writer/${writer.id}`}>
            <div className="text-[15px] text-right">
              <button className="inline-block relative after:absolute after:top-[calc(50%-4px)] after:right-0 pr-[10px] mr-[5px] after:w-[9px] after:h-[9px] text-[#2dacdb] bg-none after:border-0 after:border-t-2 after:border-r-2 after:border-[#fe8d42] border-none after:border-solid after:rotate-45 cursor-pointer outline-none after:content-['']">
                <span className="hover:pb-0 text-[#2dacdb] hover:text-[#23527c] hover:underline">
                  ライター詳細
                </span>
              </button>
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}
